export default class LanguageEffect {
  static async setLanguage(language) {
    return language;
  }
}
